import React from "react";
import "./AppButton.scss";

/**
 * AppButton — Reusable button component matching UX_DESIGNS design system.
 *
 * Props:
 *   variant   — "default" | "outline" | "secondary" | "ghost" | "destructive"
 *   size      — "default" | "sm" | "lg" | "icon"
 *   children  — button content
 *   className — extra class
 *   disabled  — disabled state
 *   onClick   — click handler
 *   as        — render as a different element (e.g. "a", Link)
 */
const AppButton = React.forwardRef(
  (
    {
      variant = "default",
      size = "default",
      children,
      className = "",
      disabled = false,
      as: Comp = "button",
      ...props
    },
    ref
  ) => {
    const classes = [
      "app-btn",
      `app-btn--${variant}`,
      `app-btn--${size}`,
      disabled ? "app-btn--disabled" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <Comp ref={ref} className={classes} disabled={disabled} {...props}>
        {children}
      </Comp>
    );
  }
);

AppButton.displayName = "AppButton";
export default AppButton;
